/**
 * ページ遷移に関するStateを扱うモジュール
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

enum ActionTypes {
  SET_HOME_BUTTON_CLICKED = 'app/pageTransition/SET_HOME_BUTTON_CLICKED'
}

/**
 * ホームボタンが押されたかどうかを設定する
 */
export const setHomeButtonClicked = (payload: boolean) =>
  createAction(ActionTypes.SET_HOME_BUTTON_CLICKED, payload);

const actions = {
  setHomeButtonClicked
};

type pageTransitionAction = ActionsUnion<typeof actions>;

/** ページ遷移に関するState */
export interface PageTransitionState {
  isHomeButtonClicked: boolean;
}

const initialState: PageTransitionState = {
  isHomeButtonClicked: false
};

export default (
  state: PageTransitionState = initialState,
  actions: pageTransitionAction
): PageTransitionState => {
  switch (actions.type) {
    case ActionTypes.SET_HOME_BUTTON_CLICKED:
      return {
        ...state,
        isHomeButtonClicked: actions.payload
      };
    default:
      return state;
  }
};
